import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { handleError } from 'src/app/utils/erro-handler';
import { getApiUrl } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AdminUserService {

  readonly BASE_URL = getApiUrl()
  readonly USER_URL = "users"
  constructor(private http: HttpClient) { }



  getUserList() {
    return this.http.get(`${this.BASE_URL}/${this.USER_URL}/list/`)
      .pipe(
        catchError(handleError)
      );
  }

  getUserRoles() {
    return this.http.get(`${this.BASE_URL}/${this.USER_URL}/role/list`)
      .pipe(
        catchError(handleError)
      );
  }
  
}
